import { render } from "./LoginAndAuthComponent.vue?vue&type=template&id=a5445de4&scoped=true&lang=pug"
import script from "./LoginAndAuthComponent.vue?vue&type=script&lang=js"
export * from "./LoginAndAuthComponent.vue?vue&type=script&lang=js"

import "./LoginAndAuthComponent.vue?vue&type=style&index=0&id=a5445de4&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5445de4"]])

export default __exports__